import { Action } from 'redux';
import { Workspace, WorkspaceSetting } from '../../types/Metadata';
import { UserSettings } from '../../types/UserSetting';
import { StatusCategories } from '../../types/StatusCategory';
import { DataMapping } from '../../types/DataMapping';
import { ItemTypes } from '../../types/ItemTypes';
import { NodeType } from '../../enums/NodeType';
import { getSchema } from '../../utils';
import { findOne } from 'rcd-cpp-workspace/utils/array';
import { ContentTypeConfig } from '../../types/ContentTypeConfiguration';
import { View } from '../../types/View';
import { Metadata } from '../../types/Metadata';

export interface PlanningState {
  regressionMode?: boolean;
  workspaces?: Workspace[];
  selectedWorkspace?: Workspace;
  userSettings?: UserSettings;
  statusCategories?: StatusCategories;
  dataMapping?: DataMapping;
  showHomeWorkspaceModal?: boolean;
  itemTypes?: ItemTypes;
  contentTypeConfigurations?: ContentTypeConfig[];
  previewFolders?: View.Folder[];
  previewRootViews?: View.Setting[];
  practiceCors?: { [practiceRefId: string]: Metadata };
  lastCreatedItems?: { [itemType: string]: Metadata };
}

const UPDATE_PLANNING_STATE = 'UPDATE_PLANNING_STATE';
const UPDATE_WORKSPACE_SETTING = 'UPDATE_WORKSPACE_SETTING';
const UPDATE_SHOW_HOME_WORKSPACE_MODAL = 'UPDATE_SHOW_HOME_WORKSPACE_MODAL';
const UPDATE_REGRESSION_MODE = 'UPDATE_REGRESSION_MODE';

export const toggleShowHomeWorkspaceModal = (
  showHomeWorkspaceModal: boolean
) => ({
  type: UPDATE_SHOW_HOME_WORKSPACE_MODAL,
  showHomeWorkspaceModal
});

export const updateWorkspaceSetting = (refId, setting: WorkspaceSetting) => ({
  type: UPDATE_WORKSPACE_SETTING,
  refId,
  setting
});

export const updatePlanningState = (newState: Partial<PlanningState>) => ({
  type: UPDATE_PLANNING_STATE,
  ...newState
});

type PlanningAction = Action &
  Partial<PlanningState> & { refId: string; setting: WorkspaceSetting };

const planningReducer = (
  state: PlanningState = {},
  action: PlanningAction
): PlanningState => {
  const { type, refId, setting, showHomeWorkspaceModal, ...s } = action;
  switch (type) {
    case UPDATE_REGRESSION_MODE:
      return { ...state, regressionMode: true };
    case UPDATE_SHOW_HOME_WORKSPACE_MODAL:
      return {
        ...state,
        showHomeWorkspaceModal
      };
    case UPDATE_PLANNING_STATE:
      if (s.selectedWorkspace && !s.itemTypes) {
        const schema = getSchema(s.selectedWorkspace.schemas, NodeType.Item);
        if (schema?.props?.fields) {
          const itemTypeField = findOne(schema.props.fields, {
            field: 'itemType'
          });
          if (itemTypeField.enumValues)
            s.itemTypes = itemTypeField.enumValues as ItemTypes;
        }
      }
      return { ...state, ...s };
    case UPDATE_WORKSPACE_SETTING:
      const w = state.selectedWorkspace;
      if (refId && setting && w) {
        if (w.props?.refId == refId) {
          if (
            !w.setting?.timeLoaded ||
            w.setting.timeLoaded < setting.timeLoaded
          ) {
            w.setting = setting;
            return { ...state, selectedWorkspace: { ...w } };
          }
        }
      }
      return state;
    default:
      return state;
  }
};

export default planningReducer;
